import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';
import { CompanyConfiguration } from '@app-model/company';


@Injectable({
	providedIn: 'root'
})
export class ConfigurationService {
	constructor(private http: HttpClient) {}

	getCompanies() {
		return this.http.get(`${environment.api}/configurations/getCompaniesBasic`).pipe(
			map((response: any) => {
				if (Array.isArray(response)) {
					return response.sort(function (a, b) {
						return a.companyName.toUpperCase() > b.companyName.toUpperCase()
							? 1
							: b.companyName.toUpperCase() > a.companyName.toUpperCase()
							? -1
							: 0;
					});
				}
				return response;
			})
		);
	}

	getCompaniesWithManaged() {
		return this.http.get(`${environment.api}/configurations/getCompaniesManager`).pipe(
			map((response: any) => {
				if (Array.isArray(response)) {
					return response.sort(function (a, b) {
						return a.companyName.toUpperCase() > b.companyName.toUpperCase()
							? 1
							: b.companyName.toUpperCase() > a.companyName.toUpperCase()
							? -1
							: 0;
					});
				}
				return response;
			})
		);
	}

	getCompanyById(companyId) {
		return this.http
			.get(`${environment.api}/configurations/getCompanyById/${companyId}`)
			.pipe(
				map((response: any) => {
					if (Array.isArray(response)) {
						return response.sort(function (a, b) {
							return a.companyName.toUpperCase() > b.companyName.toUpperCase()
								? 1
								: b.companyName.toUpperCase() > a.companyName.toUpperCase()
								? -1
								: 0;
						});
					}
					return response;
				})
			);
	}

	getDepartament(departamentId): Observable<object> {
		return this.http.get(
			`${environment.api}/configurations/getDepartament/${departamentId}`
		);
	}
	getRole(roleId): Observable<object> {
		return this.http.get(`${environment.api}/configurations/getRole/${roleId}`);
	}

	getDepartaments(companyId): Observable<object> {
		return this.http.get(`${environment.api}/configurations/getDepartaments/${companyId}`);
	}
	getRoles(companyId): Observable<object> {
		return this.http.get(`${environment.api}/configurations/getRoles/${companyId}`);
	}

	getMasterCompanies(): Observable<object> {
		return this.http.get(`${environment.api}/configurations/getMasterCompanies`);
	}
	getCompany(companyId): Observable<CompanyConfiguration> {
		return this.http.get(`${environment.api}/configurations/getCompany/${companyId}`);
	}
	getSubsidiariesCompanies(companyId): Observable<object> {
		return this.http.get(`${environment.api}configurations/getSubsidiariesCompanies/${companyId}`
		);
	}
}
